export default "__VITE_ASSET__PprDAn_y__"